export const MEASUREMENTS = 'MEASUREMENTS';

export const INIT_STATE = {
	measurements: {}
}


// WEBPACK FOOTER //
// ./src/stance/constants/index.js